export const MUTATION_KEYS = {
    agent_invitation: 'agent-invitation',
    delete_agent: 'delete-agent',
    agentInvitationV3: 'agentInvitationV3',
    deleteAgentV3: 'deleteAgentV3'
}

export const QUERY_KEYS = {
    agent_accept_request: 'agent-accept-request',
    verify_agent_invitation: 'verify-agent-invitation',
    agent_rookies: 'agent-rookies',
    agent_representatives: 'agent-representatives',
    modes: 'modes',
    agentAcceptRequestV3: 'agentAcceptRequestV3',
    verifyAgentInvitationV3: 'verifyAgentInvitationV3',
    agentRookiesV3: 'agentRookiesV3',
    agentRepresentativesV3: 'agentRepresentativesV3',
    modesV3: 'modesV3'
}
